const barDefaults = {
  startColor: '#FFFFFF',
  startColorOpacity: 0.5,
  endColor: '#FFFFFF',
  endColorOpacity: 0,
  radiusTop: 4,
  radiusBottom: 4,
  height: 100,
};

export default barDefaults;
